import React from 'react';
import CreateCloudfrontUrl from '../../../services/CreateCloudfrontUrl';
import './style.css';

const HouseCenter = () => {

    const houseFilename = "quoll-homepage-home-felt.webp"
    return (
        <div className="house-center-container">
            {/* Connection point for React Flow at top */}
            <div
                id="house-top-point"
                className="house-connection-point house-top"
            />

            <img
                src={CreateCloudfrontUrl(houseFilename)}
                alt="House"
                className="house-center-image"
            />

            {/* Connection point for React Flow at bottom */}
            <div
                id="house-bottom-point"
                className="house-connection-point house-bottom"
            />
        </div>
    );
};

export default HouseCenter;
